import { GET_BIKE_BRANDS_REQUEST, GET_BIKE_BRANDS_SUCCESS, GET_BIKE_BRANDS_FAILURE } from '../constants/get_bike_brands.constants';

export const getBikeBrandsRequest = params => ({
    type: GET_BIKE_BRANDS_REQUEST,
    params,
});

export const getBikeBrandsSuccess = payload => ({
    type: GET_BIKE_BRANDS_SUCCESS, payload,
});

export const getBikeBrandsFailure = error => ({
    type: GET_BIKE_BRANDS_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/actions/get_bike_brands.actions.js